<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      :hide-overlay="!dialog"
      @keydown.esc="dialog = false"
      :fullscreen="is_mobile"
      :scrollable="is_mobile"
      width="500"
      overlay-opacity="50"
      overlay-color="#ffffff"
      content-class="default-dialog"
    >
      <template v-slot:activator="{}">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              @click.stop="dialog = true"
              icon
            >
              <v-icon>mdi-database-search</v-icon>
            </v-btn>
          </template>
          <span>{{ lang.global.filters }}</span>
        </v-tooltip>
        <v-divider
          inset
          vertical
        ></v-divider>
      </template>

      <v-card v-if="dialog">
        <v-card-title class="dialog-title">
          <span class="headline">
            <v-icon class="toolbar-icon">mdi-database-search</v-icon>
            {{ lang.global.filters }}
          </span>
          <v-spacer></v-spacer>
          <v-icon class="dialog-close-btn" @click="dialog = false">mdi-close</v-icon>
        </v-card-title>

        <v-card-text>
          <v-container
            v-bar="{ preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true }"
            class="overflow-y-auto dialog-scrollbar"
            style="max-height: 350px !important; padding: 0px !important;"
          >
            <v-content class="filters-content">
              <v-row justify="center">
                <v-expansion-panels flat>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="justify-self-start" disable-icon-rotate>
                      <div>
                        <v-icon medium left>mdi-calendar</v-icon>
                        <span>{{ lang.historic.filters.date_range.title }}</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-daterange
                        v-model="filters.date"
                        :presets="presets"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="justify-self-start" disable-icon-rotate>
                      <div>
                        <v-icon medium left>mdi-map-marker</v-icon>
                        <span>{{ lang.historic.filters.addresses.title }}</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <AddressAutoComp
                        v-model="filters.addresses"
                        :label="lang.historic.filters.addresses.title"
                        returnObject
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="justify-self-start" disable-icon-rotate>
                      <div>
                        <v-icon medium left>mdi-phone</v-icon>
                        <span>{{ lang.historic.filters.phones.title }}</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-autocomplete
                        v-model="filters.phones"
                        :search-input.sync="phone_input"
                        :items="phones_list"
                        :label="lang.historic.filters.phones.title"
                        clear-icon="mdi-broom"
                        autocomplete="new-password"
                        clearable
                        filled
                        chips
                        deletable-chips
                        multiple
                        hide-details
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="justify-self-start" disable-icon-rotate>
                      <div>
                        <v-icon medium left>mdi-card-bulleted</v-icon>
                        <span>{{ lang.historic.filters.identities.title }}</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-autocomplete
                        v-model="filters.identities"
                        :search-input.sync="cpf_input"
                        :items="identity_list"
                        :label="lang.historic.filters.identities.title"
                        clear-icon="mdi-broom"
                        autocomplete="new-password"
                        clearable
                        filled
                        chips
                        deletable-chips
                        multiple
                        hide-details
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <!-- <v-expansion-panel>
                    <v-expansion-panel-header class="justify-self-start" disable-icon-rotate>
                      <div>
                        <v-icon medium left>mdi-cash-multiple</v-icon>
                        <span>{{ lang.historic.filters.payment.methods }}</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-autocomplete
                        v-model="filters.payment"
                        :items="[{ id: 1, title: lang.historic.filters.payment.money }, { id: 2, title: lang.historic.filters.payment.debit }, { id: 3, title: lang.historic.filters.payment.credit }]"
                        :label="lang.historic.filters.payment.methods"
                        :clearable="true"
                        item-text="title"
                        item-value="id"
                        clear-icon="mdi-broom"
                        autocomplete="new-password"
                        filled
                        chips
                        deletable-chips
                        multiple
                        hide-details
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel> -->
                </v-expansion-panels>
              </v-row>
            </v-content>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click.stop="reset()"
          >
            {{ lang.historic.filters.reset }}
          </v-btn>
          <v-btn
            color="green"
            text
            @click.stop="apply()"
          >
            {{ lang.historic.filters.apply }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AddressAutoComp from '@/components/customers/templates/addresses/AutoComplete'
import daterange from '@/components/utils/daterange/mixins'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import defaults from '@/mixins/defaults/filters'

export default {
  components: { AddressAutoComp },
  mixins: [ appdata, utils, daterange ],
  data () {
    return {
      dialog: false,
      filters: {},
      search: {
        phone: '',
        cpf: ''
      }
    }
  },
  watch: {
    dialog (val) {
      if (val) this.refresh()
    },
    search: {
      deep: true,
      handler (newVal) {
        if (this.search.phone !== newVal.phone) this.search.phone = this.phoneMask(newVal.phone)
        if (this.search.cpf !== newVal.cpf) this.search.cpf = this.cpfMask(newVal.cpf)
      }
    }
  },
  computed: {
    cpf_input: {
      get: function () {
        return this.search.cpf
      },
      set: function (newValue) {
        this.search.cpf = this.cpfMask(newValue)
      }
    },
    phone_input: {
      get: function () {
        return this.search.cpf
      },
      set: function (newValue) {
        this.search.phone = this.phoneMask(newValue)
      }
    },
    identity_list () {
      const cpflist = this.get_data.customers.map(function (el) { return this.cpfMask(el.identity) }.bind(this))
      const unique = [...new Set(cpflist)]
      return unique
    },
    phones_list () {
      const phonelist = this.get_data.customers.map(function (el) { return this.phoneMask(el.phone) }.bind(this))
      const unique = [...new Set(phonelist)]
      return unique
    }
  },
  methods: {
    refresh () {
      const globalFilters = (this.get_global.filters.customers && this.get_global.filters.customers.data ? { ...this.get_global.filters.customers.data } : { ...defaults.customers.data })
      this.filters = { ...globalFilters }
    },
    reset () {
      this.filters = (defaults.customers.data ? { ...defaults.customers.data } : [])
    },
    apply () {
      const applyFilters = {
        customers: {
          page: 6,
          data: { ...this.filters }
        }
      }
      this.$store.dispatch('setGlobalFilters', Object.assign({}, { ...applyFilters }))
      this.$store.dispatch('socket/CUSTOM_DATA', this.get_global.filters)
      this.dialog = false
    }
  },
  created () {
    this.refresh()
  }
}
</script>

<style scoped>
#app .v-dialog > .v-card > .v-card__text {
  padding: 0px 9px 0px 9px;
}
#app .filters-content {
  padding: 0px !important;
}
</style>
